import { render, staticRenderFns } from "./CookiesNotification.vue?vue&type=template&id=6dadf254"
import script from "./CookiesNotification.vue?vue&type=script&lang=js"
export * from "./CookiesNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports